import { render, staticRenderFns } from "./Monitoring.vue?vue&type=template&id=7bd8f070&scoped=true&"
import script from "./Monitoring.vue?vue&type=script&lang=js&"
export * from "./Monitoring.vue?vue&type=script&lang=js&"
import style0 from "./Monitoring.vue?vue&type=style&index=0&id=7bd8f070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd8f070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd8f070')) {
      api.createRecord('7bd8f070', component.options)
    } else {
      api.reload('7bd8f070', component.options)
    }
    module.hot.accept("./Monitoring.vue?vue&type=template&id=7bd8f070&scoped=true&", function () {
      api.rerender('7bd8f070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/service/Monitoring.vue"
export default component.exports